import ApiConstants from '../constants/ApiConstants';
import Utility from '../utility/Utility';
import http from "../http";
import axios from 'axios';

export interface CustomFieldAPIConfig {
    Limit?: number;
    CurrentPage?: number;
    Order?: string;
    Field?: string;
    Module?: string

}

const defaultConfig: CustomFieldAPIConfig = {
    Limit: 20,
    CurrentPage: 1,
    Order: 'desc',
    Field: '_id',
    Module: '',
};

class CustomFieldService {
    static apiConfig: CustomFieldAPIConfig;

    static getPayrollByPage() {
        if (Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig;
        }
        const url = ApiConstants.URL.PEOPLE.TENANT + "/custom-fields";
        return http
            .get(`${url}?limit=${this.apiConfig.Limit}&currentPage=${this.apiConfig.CurrentPage}&orderBy.order=${this.apiConfig.Order}&orderBy.field=${this.apiConfig.Field}&module=${this.apiConfig.Module}`)
            .catch((err: any) => {
                console.error('Error loading custom fields: ', err);
                return Promise.reject(err);
            });
    }

    static getCustomFields() {
        const url = ApiConstants.URL.PEOPLE.TENANT + "/custom-fields"
        return http.get(`${url}\?module=${this.apiConfig.Module}`);
    }

    static exportCustomFields() {
        return axios.create().request({
            withCredentials: true,
            baseURL: ApiConstants.URL.BASE,
            method: "POST",
            url: "v1/exim/custom-fields?format=XLSX",
            responseType: "blob"
        });
    }
}

export default CustomFieldService
